import { darken } from 'polished';

import { getThemeProps } from 'ravenjs/utils/theme';

import { COLOR_TOKENS } from 'constants/quartz/color_tokens';

/*
 * Brand-aware color resolvers for Quartz components.
 *
 * Quartz components would otherwise read `COLOR_TOKENS` statically and so never
 * see partner branding. These resolvers read the partner value from the theme
 * built by `buildThemeWithConfig` and fall back to the Quartz token, so partner
 * branding outranks Quartz for the slots a partner owns.
 */

/**
 * Darken a color, returning it untouched when it cannot be parsed.
 *
 * @method safeDarken
 * @param  {number}   amount The amount to darken by
 * @param  {string}   color  The color to darken
 * @return {string}          The darkened color
 */
const safeDarken = (amount, color) => {
    try {
        return darken(amount, color);
    } catch (error) {
        return color;
    }
};

export const brandLinkColor = getThemeProps('palette.links.color', COLOR_TOKENS.text.link);

export const brandLinkHoverColor = props => {
    const color = brandLinkColor(props);

    return color === COLOR_TOKENS.text.link ? COLOR_TOKENS.text.linkHover : safeDarken(0.1, color);
};

export const brandPrimaryBackground = getThemeProps(
    'palette.primary.gradientColor',
    COLOR_TOKENS.button.primary.background
);

export const brandPrimaryText = getThemeProps(
    'palette.primary.text',
    COLOR_TOKENS.button.primary.text
);

export const brandPrimaryBackgroundHover = props => {
    const background = brandPrimaryBackground(props);

    return background === COLOR_TOKENS.button.primary.background
        ? COLOR_TOKENS.button.primary.backgroundHover
        : safeDarken(0.1, background);
};
